import React from "react";

import { Icon } from "./icons";

export type SetupStep = {
  key: string;
  title: string;
  sub?: React.ReactNode;
  /** A button on the right; gone once the step is done. */
  action?: React.ReactNode;
  /** Wider content under the text (an install command); gone once done. */
  detail?: React.ReactNode;
  done?: boolean;
  /** The step the page is listening for; it ticks itself off. */
  waiting?: boolean;
};

export function SetupSteps({ steps }: { steps: SetupStep[] }) {
  return (
    <ol className="ds-setup-steps">
      {steps.map((s, i) => (
        <li
          key={s.key}
          className={s.done ? "done" : s.waiting ? "waiting" : undefined}
        >
          <span
            className="ds-setup-mark"
            role="img"
            aria-label={
              s.done ? "Done" : s.waiting ? "Waiting" : `Step ${i + 1}`
            }
          >
            {s.done ? (
              <Icon name="check" size={14} />
            ) : s.waiting ? (
              <Icon name="pulse" size={14} />
            ) : (
              i + 1
            )}
          </span>
          <span className="ds-setup-text">
            <span className="ds-setup-title">{s.title}</span>
            {!s.done && s.sub && <span className="ds-setup-sub">{s.sub}</span>}
          </span>
          {!s.done && s.action && (
            <span className="ds-setup-act">{s.action}</span>
          )}
          {!s.done && s.detail && (
            <div className="ds-setup-detail">{s.detail}</div>
          )}
        </li>
      ))}
    </ol>
  );
}
